// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"5326cbb7","208":"6fd93892","236":"cd0d02e0","353":"e935ed36","512":"4758bd32","549":"ce0d97d8","813":"8fc8e3dd"}[chunkId] + ".chunk.js";
};